export default class NotificationRuleDetailCtrl{
  constructor($scope, $state,$stateParams, GeneralSettingsSrv){

    var notificationRuleVm = this

    notificationRuleVm.notification = {}

    notificationRuleVm.notification.roles = []
    notificationRuleVm.notification.days = []
    notificationRuleVm.notification.daysBefore = []
    notificationRuleVm.notification.deliveryTypes = []
    notificationRuleVm.notification.specific_date = null

    notificationRuleVm.stages = []
    notificationRuleVm.academicUnits = []
    notificationRuleVm.roles = []
    notificationRuleVm.activities = []
    notificationRuleVm.deliveryTypes = []
    notificationRuleVm.templates = []
    notificationRuleVm.weekdays = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes']
    notificationRuleVm.notificationType=[]

    notificationRuleVm.isRoleChecked = isRoleChecked
    notificationRuleVm.isDeliveryTypeChecked = isDeliveryTypeChecked
    notificationRuleVm.isDayChecked = isDayChecked

    activate()

    function activate() {

      if( !$stateParams.notificationId ) $state.go('generalSettings.notificationsManagement');

      return getAllDataNotificationRules().then(
        getNotification($stateParams.notificationId).then( () => {} )
      );
    }

    function isRoleChecked( roleId ) {
      return ( notificationRuleVm.notification.roles )? notificationRuleVm.notification.roles.includes( roleId.toString() ) : false;
    }


    function isDeliveryTypeChecked( deliveryTypeId ) {
      return (notificationRuleVm.notification.deliveryTypes)? notificationRuleVm.notification.deliveryTypes.includes( deliveryTypeId.toString() ) : false;
    }

    function isDayChecked( day ) {
      return (notificationRuleVm.notification.days)? notificationRuleVm.notification.days.includes( day.toString() ) : false;
    }

    function getAllDataNotificationRules() {
      return GeneralSettingsSrv.getAllDataNotificationRules.getList().$promise.then(function(dataReturn) {
        if( dataReturn.status == true ){

          loadFormData( dataReturn );

        }else{
          notificationRuleVm.stages = []
        }

        },function(data) {
          console.log(data)
      })
    }

    function getNotification( notificationId ) {
      return GeneralSettingsSrv.getNotificationById.get({notificationId: notificationId}).$promise.then(function(dataReturn) {
        if( dataReturn.status == true ){
          if( dataReturn.data )
          {
            if ( !dataReturn.data[0] || dataReturn.data[0].id_create_notification_type != 1 )
              $state.go('generalSettings.notificationsManagement');

            notificationRuleVm.notification = formatNotification( dataReturn.data[0] )
            console.log(notificationRuleVm.notification)
          }
        }else{

        }

        },function(data) {
          console.log(data)
      })
    }

    function loadFormData( data ) {
      notificationRuleVm.stages = ( data.stages )? data.stages : []
      notificationRuleVm.academicUnits = ( data.academic_units )? data.academic_units : []
      notificationRuleVm.roles = ( data.role )? data.role : []
      notificationRuleVm.activities = ( data.submodules )? data.submodules : []
      notificationRuleVm.deliveryTypes = ( data.delivery_type )? data.delivery_type : []
      notificationRuleVm.templates = ( data.templates )? data.templates : []
      notificationRuleVm.notificationType = ( data.notification_type )? data.notification_type : []
    }

    function formatNotification ( notification) {

      if( notification.id_role )
        notification.roles = notification.id_role.split(',')

      if ( notification.id_schedule_notification_type == 3 )
      {
        notification.shipping_time = 'dependent'
      }else{
        notification.shipping_time = 'weekly'
      }

      if( notification.ds_days_before )
      {

        notification.daysBefore = notification.ds_days_before.split(',')

        if( notification.daysBefore.includes('1') )
          notification.oneDayBefore = true;
        if( notification.daysBefore.includes('2') )
          notification.twoDaysBefore = true;
        if( notification.daysBefore.includes('5') )
          notification.fiveDaysBefore = true;

        let nDays = null
        if( nDays = notification.daysBefore.find( day => !["1","2","5"].includes( day ) ) )
          notification.nDaysBefore = parseInt(nDays)
      }

      if( notification.ds_days )
        notification.days = notification.ds_days.split(',')

      if( notification.id_notification_delivery_type )
        notification.deliveryTypes = notification.id_notification_delivery_type.split(',');

      if( notification.specific_date )
        notification.specific_date = moment( notification.specific_date , 'YYYY-MM-DD').toDate()


      return notification
    }

  }//FIN DEL CONSTRUCTOR

      preventInput(event){
      var  vKey = 86
      if (event.keyCode == vKey)
        event.preventDefault()
      return;     
    }
}

NotificationRuleDetailCtrl.$inject = ['$scope', '$state','$stateParams','GeneralSettingsSrv']


// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/notifications/rules/notificationRuleDetailCtrl.js